import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import '@stubhub/react-font-icons';
import {BANNER_LEGAL_DISCLAIMER} from './config';
import './styles.scss';

const LegalBanner = ({onClose}) => {
  return (
    <div className="Legal-Banner" data-testid="legalDisclaimer">
      <div className="Legal-Banner--content">
        <span className="Legal-Banner--text">
          <FormattedMessage {...BANNER_LEGAL_DISCLAIMER.text}/>
        </span>
        <div className="Legal-Banner--close">
          <span className="Legal-Banner--closeIcon sh-iconset sh-iconset-close" onClick={onClose}></span>
        </div>
      </div>
    </div>);
};

LegalBanner.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default LegalBanner;
